import api from './api';

const activitySuspensionService = {
  async getStatus() {
    console.log('[activitySuspensionService] GET /activity-suspension');
    const response = await api.get('/activity-suspension');
    console.log('[activitySuspensionService] getStatus response:', response.data);
    return response.data?.data || response.data;
  },

  async suspend(reason) {
    console.log('[activitySuspensionService] POST /activity-suspension/suspend', { reason });
    const response = await api.post('/activity-suspension/suspend', { reason });
    console.log('[activitySuspensionService] suspend response:', response.data);
    return response.data?.data || response.data;
  },

  async reactivate(reason) {
    console.log('[activitySuspensionService] POST /activity-suspension/reactivate', { reason });
    const response = await api.post('/activity-suspension/reactivate', { reason });
    console.log('[activitySuspensionService] reactivate response:', response.data);
    return response.data?.data || response.data;
  }
};

export default activitySuspensionService;